export const SOURCE_FORM_SECTION_UPDATED = "SOURCE_FORM_SECTION_UPDATED";
export const ANSWERS_UPDATED = "ANSWERS_UPDATED";
export const SECTION_NOT_FOUND = "SECTION_NOT_FOUND";
export const MOVING_TO_NEXT_SECTION = "MOVING_TO_NEXT_SECTION";
export const MOVING_TO_PREVIOUS_SECTION = "MOVING_TO_PREVIOUS_SECTION";
export const VALIDATE_QUESTION_REQUIRED = "VALIDATE_QUESTION_REQUIRED";
export const VALIDATE_ALL_QUESTIONS = "VALIDATE_ALL_QUESTIONS";
export const SCROLL_JUMP_FINISHED = "SCROLL_JUMP_FINISHED";
